import React from 'react';
import MuiButton, { ButtonProps as MuiButtonProps } from '@mui/material/Button';

export interface ButtonProps extends MuiButtonProps {}

// Simple Button wrapper that centralizes default props and style mapping
const DSButton = React.forwardRef<React.ComponentRef<typeof MuiButton>, ButtonProps>(
  function DSButton(
    { children, variant = 'contained', color = 'primary', ...props },
    ref,
  ) {
    return (
      <MuiButton ref={ref} variant={variant} color={color} {...props}>
        {children}
      </MuiButton>
    );
  },
);

export default DSButton;
